import { calculateDayRemaining } from "../../../util/sp-util";

export class Controller {

    /** @ngInject */
    constructor($stateParams, $window, LicenseManagementService) {
        this.$stateParams = $stateParams;
        this.$window = $window;
        this.LicenseManagementService = LicenseManagementService;

    }
 
    $onInit() {
        if(this.licenseInfo.licenseStatus == 'LICENSED') {
            this.licenseManagementSref = 'company.license-management';
        } else {
            if(this.licenseInfo.licenseStatus == 'TRIAL') {
                this.trialRemainingDays = calculateDayRemaining(this.licenseInfo.endOfTrialPeriod)
            }
            this.licenseManagementSref = 'company.license-management.purchase-license';
        }
    }

    $onChanges() {
    }

    setPaymentMethod() {
        this.LicenseManagementService.setPaymentMethod(this.$stateParams.companyId)
            .then((url)=> {
                this.$window.open(url, '_blank');
            }) 
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-license-info/sp-license-info.controller.js